var exports = {
  "Z": "xcc377c0b--c9aeb3--layout",
};

module.exports = exports;
